var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"create-upsell-item-page"},[_c('BackTitle',{staticClass:"mb-40",attrs:{"confirm-click":""},on:{"click":_vm.goBack}},[_vm._v(" Create upsell merchandise ")]),_c('UpsellItemForm',{attrs:{"value":_vm.upsellItem,"is-submitting":_vm.isSubmitting,"data-v-step":"12"},on:{"submit":_vm.handleSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }